<ul class="{{ root ? 'root' : '' }}">
  <ng-container *ngFor="let node of items">
    <li class="{{ root ? 'root' : '' }}" *ngIf="!node.hide">
      <i
        *ngIf="node.children?.length"
        class="fa fa-{{ node.expanded ? 'minus' : 'plus' }}-square-o"
        (click)="node.expanded = !node.expanded; expand(node)"
      ></i>
      <span class="node-level" [ngStyle]="{'margin-left': node.children?.length ? '15px' : '0'}">#{{ node.email }}</span>
      <a
        href="javascript: void(0)"
        [ngClass]="{
          'text-red': node.type === 2,
          '': node.type === 1
        }"
        (click)="selectItem(node)"
        >{{ node.text }}</a
      >
      <input type="checkbox" name="mode" [(ngModel)]="node.mode" (change)="handleModeData(node)"/>
      <div [ngClass]="{ 'expanded': node.expanded }" *ngIf="node.children" class="line">
        <fx-bonus-treeview
          [root]="false"
          [items]="node.children"
          (expanded)="onExpanded($event)"
          (moded)="handleModeData($event)"
          (slct)="onSelectItem($event)"
        ></fx-bonus-treeview>
      </div>
    </li>
  </ng-container>
</ul>
